;(function () {
  'use strict'

  angular
    .module('contrast.org.trace.events')
    .factory('traceEventsService', traceEventsServiceFactory)

  function traceEventsServiceFactory(
    $uibModal,
    ServiceUtils,
    appTracesApiConfig,
    currentTraceService
  ) {
    'ngInject'

    var service = {
      getEventDetails: getEventDetails,
      addSecurityControl: addSecurityControl,
      getEventApi: getEventApi
    }

    return service

    function getEventDetails(traceUuid, eventId) {
      return appTracesApiConfig
        .getEventDetails(traceUuid, eventId)
        .then(ServiceUtils.handleResolve('data.event'))
        .catch(ServiceUtils.handleError)
    }

    function getEventApi(event) {
      return event.details.class + '.' + event.details.method
    }

    function addSecurityControl(event) {
      var traceUuid = event.traceUuid
      var api = getEventApi(event)
      var language = event.traceLanguage
      var preloadValues = {
        language: language,
        api: api,
        traces: [traceUuid],
        mark_status: true
      }
      $uibModal
        .open({
          templateUrl: 'views/rules/modal_control.html',
          controller: 'ModalAddControlInstanceCtrl',
          resolve: {
            preloadValuesData: function () {
              return preloadValues
            }
          }
        })
        .result.then(function () {
          // Get the updated trace and broadcast that the changes are available
          currentTraceService.get({ broadcast: true })
        })
    }
  }
})()
